export const state = {
  cities: [],
  countries: [],
  organizationTypes: [],
  currencies: [],
  weightUnits: [],
  currentRubleExchangeRate: null,
  citiesLoadedWithParams: false,
}
